import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import {Grid} from "@mui/material";

// Components
import CustomButton from "components/CustomButton";
import Popup from "components/WMS/Mobile/Popup";
import FakeSelectInput from "components/radioGroup/FakeSelectInput";

// Local Components
import TrackingNumberBlue from "../../../components/TrackingNumberBlue";
import ExternalId from "../../../components/ExternalId";
import CancellationReasonDrawer from "./components/CancellationReasonDrawer";

// Domain
import {getTranslation} from "domain/helpers/translations";

// Assets
import {ReactComponent as BagIcon} from "assets/img/wms/bag.svg"

// Api
import {wmsTakeout} from "api/shipment/wmsTakeout";

// Context
import {ClickAndCollectListContext} from "../../context/ClickAndCollectListContext";

TakeoutShipmentPopup.propTypes = {
    cancellationReasons: PropTypes.arrayOf(PropTypes.object).isRequired
};

function TakeoutShipmentPopup({cancellationReasons}) {
    const {
        setSelectedShipment,
        selectedShipment,
        refreshShipments,
        openToast
    } = useContext(ClickAndCollectListContext);

    const [selectedReason, setSelectedReason] = React.useState(null);
    const [loading, setLoading] = useState(false);

    const [openCancellationDrawer, setOpenCancellationDrawer] = React.useState(false);

    return (
        <div>
            <Popup
                title={<FormattedMessage id='wms.cc.list.takeoutShipment.popup.title' />}
                subtitle={<FormattedMessage id='wms.cc.list.takeoutShipment.popup.subtitle' />}
                open={selectedShipment !== null}
                icon={<BagIcon />}
                isMobile={true}
                onClose={() => {
                    setSelectedReason(null);
                    setSelectedShipment(null);
                }}
                sx={openCancellationDrawer && {
                    '& .MuiPaper-root ': {
                        margin: '0px',
                    }
                }}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                textAlign: 'center'
                            }}
                        >
                            <TrackingNumberBlue trackingNumber={selectedShipment.trackingNumber} />
                            <ExternalId externalId={selectedShipment.order.externalId} />
                            <div style={{ marginTop: '16px' }}>
                                <FakeSelectInput
                                    text={selectedReason ? getTranslation(selectedReason).name : <FormattedMessage id='wms.cc.list.takeoutShipment.popup.cancellationReason.select' />}
                                    onClick={() => setOpenCancellationDrawer(true)}
                                />
                            </div>
                        </div>
                    </Grid>
                    <Grid
                        item
                        container
                        direction={'column'}
                        spacing={2}
                        marginTop={4}
                    >
                        <Grid item>
                            <CustomButton
                                fullWidth={true}
                                thicker={true}
                                color={'blue'}
                                disabled={!selectedReason || loading}
                                onClick={() => {
                                    setLoading(true)
                                    wmsTakeout(selectedShipment, selectedReason).then(r => {
                                        setSelectedShipment(null);
                                        openToast();
                                        refreshShipments();
                                    }).finally(() => setLoading(false));
                                }}
                            >
                                <FormattedMessage id='wms.cc.list.takeoutShipment.popup.action.validate' />
                            </CustomButton>
                        </Grid>
                        <Grid item>
                            <CustomButton
                                onClick={() => setSelectedShipment(null)}
                                fullWidth={true}
                                thicker={true}
                                color={'default'}
                                disabled={loading}
                            >
                                <FormattedMessage id='wms.cc.list.takeoutShipment.popup.action.cancel' />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Grid>
                <CancellationReasonDrawer
                    isOpen={openCancellationDrawer}
                    handleClose={() => setOpenCancellationDrawer(false)}
                    cancellationReasons={cancellationReasons}
                    setSelectedReason={setSelectedReason}
                />
            </Popup>
        </div>
    );
}

export default TakeoutShipmentPopup;
